import { TranslocoMissingHandler } from '@jsverse/transloco';
import { logger } from '@ts/shared/logging/util-core';

export class I18nMissingHandler implements TranslocoMissingHandler {
  handle(key: string /* , config: TranslocoConfig */) {
    logger.error(`Missing translation for key "${key}"`);
    return key;
  }
}
